<template>
  <div class="container">
    <h2 class="mb-5">Profile</h2>
    <form
      style="margin: 0 auto; max-width: 600px;"
      @submit.prevent="onSubmit"
      :data-vv-scope="formScope"
    >
      <h4 class="mt-4 mb-4">Personal data</h4>

      <base-text
        name="name"
        v-validate="'required'"
        label="Name"
        v-model="user.name"
        :err="errors.collect('name', formScope)"
      ></base-text>

      <base-text
        name="email"
        v-validate="'required|email'"
        label="Email address"
        v-model="user.email"
        :err="errors.collect('email', formScope)"
        :disabled="true"
      ></base-text>

      <base-text
        name="password"
        v-validate="'min:6'"
        type="password"
        ref="password"
        label="Change password"
        v-model="passwords.password"
        :err="errors.collect('password', formScope)"
      ></base-text>

      <base-text
        v-if="passwords.password !== ''"
        name="c_password"
        type="password"
        label="Confirm password"
        v-validate="'required|confirmed:password'"
        data-vv-as="passwords.password"
        v-model="passwords.c_password"
        :err="errors.collect('c_password', formScope)"
      />

      <base-checkbox
        v-if="isRepresentative === false"
        style="margin: 8px 0 10px 0;"
        class="d-inline-block mb-0"
        v-model="user.is_input"
        label="Input user"
      ></base-checkbox>

      <div v-if="isEditableComapny">
        <h4 class="mt-4 mb-4">Company data</h4>

        <base-select
          name="country_code"
          v-validate="'required'"
          label="Country"
          v-model="company.country_code"
          :options="getCountries"
          :err="errors.collect('country_code', formScope)"
          select-label="name"
          valueBy="code"
          @input="handleCheckVat"
          disabled
        ></base-select>
        <div class="position-relative account-profile-vat-section">
          <base-text
            name="vat_number"
            v-validate="'required|min:7'"
            label="VAT"
            v-model="company.vat_number"
            @input="handleCheckVat"
            :err="errors.collect('vat_number', formScope)"
            disabled
          ></base-text>
          <button class="btn btn-warning" @click.prevent="handleRefreshData">Refresh data</button>
        </div>
        <base-text
          name="company_name"
          v-validate="'required'"
          label="Name"
          v-model="company.company_name"
          :err="errors.collect('company_name', formScope)"
          disabled
        ></base-text>

        <base-text
          name="address"
          v-validate="'required'"
          label="Address"
          v-model="company.address"
          :err="errors.collect('address', formScope)"
          disabled
        ></base-text>

        <base-text
          name="holding"
          v-validate="'required'"
          label="Holding"
          v-model="company.holding"
          :err="errors.collect('holding', formScope)"
        ></base-text>

        <base-text
          name="ceo_name"
          v-validate="'required'"
          label="Name of CEO"
          v-model="company.ceo_name"
          :err="errors.collect('ceo_name', formScope)"
        ></base-text>

        <base-text
          name="ceo_email"
          v-validate="'required'"
          label="Email of CEO"
          v-model="company.ceo_email"
          :err="errors.collect('ceo_email', formScope)"
        ></base-text>
        <h4 class="mt-4 mb-4">
          Production capacity
          <span v-tooltip.top="'Optionally add your production capacity to be able to visually track your own performance. Recovinyl will not be able to see these data.'">
            <i class="fas fa-info-circle color-blue"></i>
          </span>
        </h4>
        <base-text
          name="target"
          type="number"
          label="Production capacity per day (kg)"
          v-model="company.target"
        ></base-text>
      </div>

      <div class="row mt-4">
        <div class="col-6 text-left">
          <base-button radius="bl" component-class="blue" @click.native="$router.go(-1)">
            <i class="fas fa-arrow-left mr-3"></i> Previous
          </base-button>
        </div>
        <div class="col-6 text-right">
          <base-button
            radius="br"
            component-class="green filled"
            type="submit"
            :disabled="!isFormValid"
          >
            Save
            <i class="fas fa-arrow-right ml-3"></i>
          </base-button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import BaseText from '@/components/inputs/text/BaseText';
import BaseSelect from '@/components/inputs/select/BaseSelect';
import BaseButton from '@/components/inputs/button/BaseButton';
import BaseCheckbox from '@/components/inputs/checkbox/BaseCheckbox';

export default {
  data() {
    return {
        inputUser: true,
        formScope: 'profile',
        userCompanyId: 0,
        isFormValid: false,
        passwords: {
            password: '',
            c_password: ''
        },
        user: {
            id: 0,
            name: '',
            email: '',
            type: '',
            tonnes: false
        },
        company: {
            vat_number: null,
            company_name: '',
            address: '',
            country_code: {},
            holding: '',
            ceo_name: '',
            ceo_email: '',
            target: '',
        }
    };
  },

  computed: {
    ...mapState({
        getUser: state => state.user.user,
        getCountries: state => state.countries.countries,
        getUsuserAttachedCompanieser: state => state.user.userAttachedCompanies,
        userCompanies: state => state.userCompanies.loggedUserCompanies
    }),
    ...mapGetters({
        isAdmin: 'user/isAdmin',
        isRecycler: 'user/isRecycler'
    }),
    isEditableComapny() {
        return (
            this.userCompanies.length && (this.isRecycler || this.isAdmin)
        );
    },
    baseValidatorInputData() {
        const { name, email } = this.$validator.flags;
        return { name, email };
    },
    companyValidatorInputData() {
        const {
            vat_number,
            company_name,
            address,
            country_code,
            holding,
            ceo_name,
            ceo_email
        } = this.$validator.flags;
        return {
            vat_number,
            company_name,
            address,
            country_code,
            holding,
            ceo_name,
            ceo_email
        };
    },
    isRepresentative() {
        return this.$store.getters['user/isRepresentative'];
    }
  },

  watch: {
    inputUser(newValue) {
      localStorage.setItem('isInputUser', newValue);
      this.$store.commit('user/setUserType', newValue);
    },
    getUser(newValue) {
        this.user = { ...this.user, ...newValue };
        this.getUserAttachedCompany(this.user.id);
    },
    /**
     * Watch base input data and validate it
     */
    baseValidatorInputData: {
        handler(newValue) {
            if (newValue.name && this.validateBaseInputs(newValue)) {
                this.isFormValid = true;
            } else {
                this.isFormValid = false;
            }
        },
        deep: true
    },
    passwords: {
        handler(newValue) {
            if (newValue.password !== '') {
                if (newValue.password === newValue.c_password) {
                    this.isFormValid = true;
                } else {
                    this.isFormValid = false;
                }
            } else {
                this.isFormValid = true;
            }
        },
        deep: true
    },
    companyValidatorInputData: {
        handler(newValue) {
            if (newValue.vat_number && this.validateCompanyInputs(newValue)) {
                this.isFormValid = true;
            } else {
                this.isFormValid = false;
            }
        },
      deep: true
    },
    getUsuserAttachedCompanieser(newValue) {
        if (newValue.companies.length) {
            this.userCompanyId = newValue.companies[0];
        }
    },
    userCompanies(newValue) {
        if (newValue[0]) {
            const companyStateData = {
                company_name: newValue[0].name,
                ...newValue[0]
            };
            this.company = companyStateData;
        }
    }
  },

  methods: {
    ...mapActions({
        updateUser: 'user/updateUser',
        getUserCompanies: 'userCompanies/getCompanies',
        updateCompany: 'userCompanies/updateCompany',
        getAllCountries: 'countries/getCountries',
        getUserAttachedCompany: 'user/getUserAttachedCompany',
        checkVat: 'app/checkVat'
    }),
    async handleRefreshData() {
      try {
        await this.handleCheckVat();
        this.$snotify.success('Data refreshed.');
      } catch (error) {
        this.$snotify.error('Refresh data error.');
      }
    },
    async handleCheckVat() {
        const { country_code, vat_number } = this.company;
        // send request if vat number is min 4 digit length
        if (country_code && vat_number.length > 5) {
            try {
                const { data } = await this.checkVat({ country_code, vat_number });
                const { name, address } = data;
                this.company.company_name = name;
                this.company.address = address;
            } catch (error) {
                console.error(error);
            }
        }
    },
    async onSubmit() {
      let isError = false;
      if (this.validateBaseInputs(this.baseValidatorInputData)) {
        const { password, c_password } = this.passwords;
        const { name, tonnes, is_input } = this.user;
        const userData = {
          name,
          tonnes,
          is_input
        };

        if (password.trim() !== '' && password === c_password) {
          userData.password = this.passwords.password;
        }

        isError = await this.updateUser(userData);
        localStorage.removeItem('last_input');
        this.passwords.password = '';
        this.passwords.c_password = '';
      }

if (this.validateCompanyInputs(this.companyValidatorInputData)) {
        const companyData = {
          ...this.company,
          name: this.company.company_name,
          country_code: this.company.country_code
        };

        isError = await this.updateCompany(companyData);
      }
      if (!isError) {
        window.location.href = '/';
        // this.$router.push({ name: 'user.dashboard' });
      }
    },
    validateBaseInputs({ name, email }) {
        if (name && name.valid && email.valid) {
            return true;
        }
        return false;
    },
    isValidPassword({ password, c_password }) {
      if (
        password.changed === true &&
        password.valid !== false &&
        c_password.valid !== false
      ) {
        return true;
      }
      return false;
    },
    validateCompanyInputs({
      vat_number,
      company_name,
      address,
      country_code,
      holding,
      ceo_name,
      ceo_email
    }) {
      if (
        vat_number &&
        vat_number.valid &&
        company_name.valid &&
        address.valid &&
        country_code.valid &&
        holding.valid &&
        ceo_name.valid &&
        ceo_email.valid
      ) {
        return true;
      }
      return false;
    },
  },

  created() {
      this.$validator.extend('vat', {
          getMessage: () => 'Vat number needs to be valid',
          validate: async (value, [testProp]) => {
              console.log(value, testProp);
              try {
                  const data = await this.handleCheckVat();
                  if (data.valid) {
                      return true;
                  }
              } catch (error) {
                    console.log('error', error);
              }

              return false;
          }
      });
  },

  mounted() {
    this.user = { ...this.user, ...this.getUser };
    this.getAllCountries();
    this.getUserCompanies(this.$store.getters['user/getLoggedInUserId']);
    this.getUserAttachedCompany(this.user.id);
    this.inputUser = JSON.parse(localStorage.getItem('isInputUser'));
  },

  components: {
    'base-text': BaseText,
    'base-select': BaseSelect,
    'base-button': BaseButton,
    'base-checkbox': BaseCheckbox,
  }
};
</script>

<style lang="scss" scoped>
  .account-profile-vat-section {
    position: relative;

    button {
      position: absolute;
      top: 0;
      right: -140px;
      @media screen and (max-width: 800px) {
        position: relative;
        left: 0
      }
    }
  }
</style>